import React, { useState, useEffect } from 'react';
import { Fingerprint, X, ArrowRight } from 'lucide-react';
import { AuthService } from '@/core/application/security/AuthService';
import { useProfileStore } from '@/core/application/state/useProfileStore';

export function PasskeyBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isEnrolling, setIsEnrolling] = useState(false);
  const profile = useProfileStore((state) => state.profile);
  const isLoggedIn = profile !== null;

  useEffect(() => {
    // Solo mostrar a usuarios logueados
    if (!isLoggedIn) return;
    
    // Verificar si el usuario ya lo cerró en ESTA sesión
    const isDismissed = globalThis.window?.sessionStorage.getItem('aura_passkey_banner_dismissed');
    // Verificar si ya registró uno exitosamente (podemos guardar esto en localStorage)
    const hasPasskey = globalThis.window?.localStorage.getItem('aura_passkey_enrolled');

    if (!isDismissed && !hasPasskey) {
      // Pequeño delay para que no aparezca de golpe al cargar
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [isLoggedIn]);

  const handleDismiss = () => {
    setIsVisible(false);
    globalThis.window?.sessionStorage.setItem('aura_passkey_banner_dismissed', 'true');
  };

  const handleEnroll = async () => {
    setIsEnrolling(true);
    try {
      await AuthService.enrollPasskey();
      globalThis.window?.localStorage.setItem('aura_passkey_enrolled', 'true');
      setIsVisible(false);
      globalThis.alert('¡Huella configurada con éxito! Podrás usarla la próxima vez que inicies sesión.');
    } catch (error: any) {
      globalThis.alert(error.message || 'No se pudo configurar la huella en este momento.');
    } finally {
      setIsEnrolling(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="bg-sky-50 border border-sky-200 rounded-2xl p-4 mb-6 flex flex-row items-start justify-between gap-4 shadow-sm">
      <div className="flex flex-col md:flex-row gap-4 flex-1">
        <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center shrink-0">
          <Fingerprint size={24} className="text-sky-600" />
        </div>
        <div className="flex-1 w-full">
          <h4 className="m-0 mb-1 text-sky-800 text-[15px] font-bold">
            Entra a Aura al instante
          </h4>
          <p className="m-0 mb-3 text-sky-900 text-[14px] leading-5">
            Activa tu huella dactilar o reconocimiento facial para iniciar sesión en 1 segundo la próxima vez, sin correos ni contraseñas.
          </p>
          <button
            onClick={handleEnroll}
            disabled={isEnrolling}
            className={`w-full h-14 bg-sky-600 text-white rounded-lg flex items-center justify-center gap-2 text-[15px] font-bold transition-opacity ${isEnrolling ? 'opacity-70 cursor-not-allowed' : 'hover:bg-sky-700 cursor-pointer'}`}
          >
            {isEnrolling ? 'Configurando...' : 'Activar mi huella ahora'}
            {!isEnrolling && <ArrowRight size={18} />}
          </button>
        </div>
      </div>
      <button 
        onClick={handleDismiss}
        className="bg-transparent border-none text-sky-300 cursor-pointer p-1 flex hover:text-sky-500"
        title="Ocultar por ahora"
      >
        <X size={20} />
      </button>
    </div>
  );
}
